import CreditIcon from '../assets/credit.svg'
import PayPalIcon from '../assets/paypal.svg'
import GoogleIcon from '../assets/google.png'
import AppleIcon from '../assets/apple.svg'
import RefreshIcon from '../assets/change_content.svg'
import AchIcon from '../assets/bank.png'
import SepaIcon from '../assets/sepa.png'
import SofortIcon from '../assets/sofort.png'
import FurikomiIcon from '../assets/customer_balance.png'
import iDEALIcon from '../assets/ideal.png'
import UsBankAccount from '../assets/us_bank_account.png'
import KlarnaIcon from '../assets/klarna.png'
import P24Icon from '../assets/p24.png'
import WiseIcon from '../assets/wise.svg'
import BacsIcon from '../assets/bacs.png'
import FpsIcon from '../assets/fps.png'
import OpenBankingIcon from '../assets/us_bank_account.png'
import BankTransferIcon from '../assets/bank_transfer.svg'
import UpiIcon from '../assets/upi.png'
import CashIcon from '../assets/cash.svg'
import CheckIcon from '../assets/check.svg'
import OtherMethodIcon from '../assets/other_method.svg'
import Enums from './Enums'

export const CURRENCY_INR = 'INR'

export const SWITCH_CURRENCY = 'switch_currency'

export const CURRENCY_USD = 'USD'

export const COUNTRY_CODE_INDIA = 'IN'

export const Z_HPM_IFRAME = 'z_hppm_iframe'

export const Z_CONTAINER_ID = 'zuora_payment'

export const payMethodIconMap = {
  CreditCard: CreditIcon,
  CreditCardReferenceTransaction: CreditIcon,
  PayPal: PayPalIcon,
  AdyenApplePay: AppleIcon,
  AdyenGooglePay: GoogleIcon,
  changeContent: RefreshIcon,
  ACH: AchIcon,
  SEPA: SepaIcon,
  sofort: SofortIcon,
  customer_balance: FurikomiIcon,
  ideal: iDEALIcon,
  us_bank_account: UsBankAccount,
  klarna: KlarnaIcon,
  p24: P24Icon,
  wise: WiseIcon,
  bacs: BacsIcon,
  fps: FpsIcon,
  openbanking: OpenBankingIcon,
  cash: CashIcon,
  check: CheckIcon,
  other: OtherMethodIcon,
  bankTransfer: BankTransferIcon,
  UPI: UpiIcon
}

export const payMethodNameMap = {
  CreditCard: 'billing.payment.credit',
  CreditCardReferenceTransaction: 'billing.payment.credit',
  PayPal: 'billing.payment.paypal',
  ACH: 'billing.payment.ach.name',
  SEPA: 'billing.payment.sepa',
  AdyenApplePay: 'billing.payment.apple_pay',
  AdyenGooglePay: 'billing.payment.google_pay',
  sofort: 'billing.payment.sofort',
  customer_balance: 'billing.payment.customer_balance',
  ideal: 'billing.payment.ideal',
  us_bank_account: 'billing.payment.us_bank_account',
  klarna: 'billing.payment.klarna',
  p24: 'billing.payment.p24',
  bacs: 'billing.payment.bacs',
  fps: 'billing.payment.fps',
  openbanking: 'billing.payment.openbanking',
  upi: 'billing.payment.upi',
  // Items below are working for the Google Analytics tracking
  'apm-sofort': 'sofort',
  'apm-customer_balance': 'furikomi',
  'apm-ideal': 'ideal',
  'apm-us_bank_account': 'ach',
  'apm-klarna': 'klarna',
  'apm-p24': 'przelewy24',
  'apm-bacs': 'bacs',
  'apm-fps': 'fps',
  'apm-openbanking': 'openbanking'
}

export const payMethodClassNameMap = {
  CreditCard: 'credit-card',
  CreditCardReferenceTransaction: 'credit-card',
  PayPal: 'paypal',
  AdyenApplePay: 'apple-pay',
  AdyenGooglePay: 'google-pay',
  ACH: 'ach',
  SEPA: 'sepa',
  sofort: 'sofort',
  customer_balance: 'customer_balance',
  ideal: 'ideal',
  us_bank_account: 'us_bank_account',
  klarna: 'klarna',
  p24: 'p24',
  bacs: 'bacs',
  fps: 'fps',
  openbanking: 'openbanking'
}
export const SUPPORTED_APM_LIST = ['ideal', 'us_bank_account', 'customer_balance', 'p24']

export const payMethodMap = {
  credit: 'CreditCard',
  creditByIndia: 'CreditCardReferenceTransaction',
  paypal: 'PayPal',
  google: 'AdyenGooglePay',
  apple: 'AdyenApplePay',
  ach: 'ACH',
  sepa: 'BankTransfer',
  upi: 'UPI'
}

export const nonElectronicPayMethodMap = {
  cash: 'Cash',
  check: 'Check',
  other: 'Other',
  wireTransfer: 'WireTransfer',
  bankTransfer: 'BankTransfer'
}

export const payMethodRefreshKey = 'refresh'

export const HPM_ERROR_MAPPING = {
  errorField_creditCardExpirationMonth: 'invalid_expiry_year',
  errorField_creditCardExpirationYear: 'invalid_expiry_year',
  errorField_creditCardType: 'card_not_supported',
  errorField_creditCardNumber: 'invalid_number',
  errorField_cardSecurityCode: 'invalid_cvc',
  errorField_creditCardHolderName: 'invalid_account'
}

export const ERROR_MAPPING = {
  DEFAULT: {
    'Missing Field': 'error.billing.missing_field',
    'Invalid Card Number': 'error.billing.stripe.incorrect_number',
    'Invalid card number': 'error.billing.stripe.incorrect_number',
    'Expiration date must be a future date': 'error.billing.stripe.invalid_expiry_month',
    invalid_request: 'error.billing.stripe.generic_error',
    authentication_required: 'error.billing.stripe.authentication_required',
    approve_with_id: 'error.billing.stripe.approve_with_id',
    call_issuer: 'error.billing.stripe.call_issuer',
    card_not_supported: 'error.billing.stripe.card_not_supported',
    card_velocity_exceeded: 'error.billing.stripe.card_velocity_exceeded',
    currency_not_supported: 'error.billing.stripe.currency_not_supported',
    do_not_honor: 'error.billing.stripe.do_not_honor',
    do_not_try_again: 'error.billing.stripe.do_not_try_again',
    expired_card: 'error.billing.stripe.expired_card',
    fraudulent: 'error.billing.stripe.fraudulent',
    generic_decline: 'error.billing.stripe.generic_decline',
    incorrect_number: 'error.billing.stripe.incorrect_number',
    incorrect_cvc: 'error.billing.stripe.incorrect_cvc',
    incorrect_pin: 'error.billing.stripe.incorrect_pin',
    incorrect_zip: 'error.billing.stripe.incorrect_zip',
    insufficient_funds: 'error.billing.stripe.insufficient_funds',
    invalid_account: 'error.billing.stripe.invalid_account',
    invalid_amount: 'error.billing.stripe.invalid_amount',
    invalid_cvc: 'error.billing.stripe.invalid_cvc',
    invalid_expiry_year: 'error.billing.stripe.invalid_expiry_year',
    invalid_number: 'error.billing.stripe.invalid_number',
    invalid_pin: 'error.billing.stripe.invalid_pin',
    issuer_not_available: 'error.billing.stripe.issuer_not_available',
    lost_card: 'error.billing.stripe.lost_card',
    merchant_blacklist: 'error.billing.stripe.merchant_blacklist',
    new_account_information_available: 'error.billing.stripe.new_account_information_available',
    no_action_taken: 'error.billing.stripe.no_action_taken',
    not_permitted: 'error.billing.stripe.not_permitted',
    offline_pin_required: 'error.billing.stripe.offline_pin_required',
    online_or_offline_pin_required: 'error.billing.stripe.online_or_offline_pin_required',
    pickup_card: 'error.billing.stripe.pickup_card',
    pin_try_exceeded: 'error.billing.stripe.pin_try_exceeded',
    processing_error: 'error.billing.stripe.processing_error',
    reenter_transaction: 'error.billing.stripe.reenter_transaction',
    restricted_card: 'error.billing.stripe.restricted_card',
    revocation_of_all_authorizations: 'error.billing.stripe.revocation_of_all_authorizations',
    revocation_of_authorization: 'error.billing.stripe.revocation_of_authorization',
    security_violation: 'error.billing.stripe.security_violation',
    service_not_allowed: 'error.billing.stripe.service_not_allowed',
    stolen_card: 'error.billing.stripe.stolen_card',
    stop_payment_order: 'error.billing.stripe.stop_payment_order',
    testmode_decline: 'error.billing.stripe.testmode_decline',
    transaction_not_allowed: 'error.billing.stripe.transaction_not_allowed',
    try_again_later: 'error.billing.stripe.try_again_later',
    withdrawal_count_limit_exceeded: 'error.billing.stripe.withdrawal_count_limit_exceeded',
    card_decline_rate_limit_exceeded: 'error.billing.stripe.card_decline_rate_limit_exceeded',
    emptyField: 'billing.required',
    missingFullAddress: 'billing.enter_full_address',
    invalidEmail: 'billing.invalid',
    invalidVAT: 'billing.invalid',
    invalidCC: 'billing.invalid',
    invalidCVV: 'billing.invalid',
    invalidCoupon: 'billing.invalid',
    cardDeclined: 'billing.transaction_declined',
    acceptTOS: 'billing.accept_terms_of_service',
    invalidQuantity: 'billing.invalid_quantity',
    invalidZip: 'billing.invalid_zip',
    invalidJPZip: 'billing.invalid_jp_zip',
    invalidINZip: 'billing.invalid_in_zip',
    notEuropeanCountry: 'billing.not_european_country',
    creditCardExpirationMonth: 'billing.expirationDate',
    creditCardExpirationYear: 'billing.expirationDate',
    cardSecurityCode: 'billing.cvv',
    creditCardNumber: 'billing.credit_card_number',
    creditCardHolderName: 'billing.card_hold_name',
    specialCharacters: 'billing.enter_special_characters',
    'Required Field Not Completed': 'billing.error.required_field_not_completed'
  },
  Adyen: {
    'Transaction declined.905_3': 'error.billing.adyen.currency_not_supported',
    'Transaction declined.103': 'error.billing.adyen.invalid_cvc',
    'Transaction declined.39': 'error.billing.adyen.invalid_request',
    'Transaction declined.38': 'error.billing.adyen.invalid_request',
    'Transaction declined.37': 'error.billing.adyen.invalid_request',
    'Transaction declined.36': 'error.billing.adyen.merchant_blacklist',
    'Transaction declined.35': 'error.billing.adyen.invalid_request',
    'Transaction declined.34': 'error.billing.adyen.invalid_request',
    'Transaction declined.33': 'error.billing.adyen.do_not_try_again',
    'Transaction declined.32': 'error.billing.adyen.incorrect_zip',
    'Transaction declined.31': 'error.billing.adyen.issuer_not_available',
    'Transaction declined.29': 'error.billing.adyen.withdrawal_count_limit_exceeded',
    'Transaction declined.28': 'error.billing.adyen.insufficient_funds',
    'Transaction declined.27': 'error.billing.adyen.generic_decline',
    'Transaction declined.26': 'error.billing.adyen.offline_pin_required',
    'Transaction declined.25': 'error.billing.adyen.not_permitted',
    'Transaction declined.24': 'error.billing.adyen.expired_card',
    'Transaction declined.23': 'error.billing.adyen.online_or_offline_pin_required',
    'Transaction declined.22': 'error.billing.adyen.invalid_request',
    'Transaction declined.21': 'error.billing.adyen.invalid_request',
    'Transaction declined.20': 'error.billing.adyen.invalid_account',
    'Transaction declined.19': 'error.billing.adyen.invalid_request',
    'Transaction declined.18': 'error.billing.adyen.pickup_card',
    'Transaction declined.17': 'error.billing.adyen.incorrect_pin',
    'Transaction declined.16': 'error.billing.adyen.invalid_request',
    'Transaction declined.15': 'error.billing.adyen.invalid_request',
    'Transaction declined.14': 'error.billing.adyen.call_issuer',
    'Transaction declined.12': 'error.billing.adyen.card_velocity_exceeded',
    'Transaction declined.11': 'error.billing.adyen.invalid_request',
    'Transaction declined.10': 'error.billing.adyen.card_not_supported',
    'Transaction declined.9': 'error.billing.adyen.lost_card',
    'Transaction declined.8': 'error.billing.adyen.incorrect_number',
    'Transaction declined.7': 'error.billing.adyen.invalid_amount',
    'Transaction declined.6': 'error.billing.adyen.incorrect_cvc',
    'Transaction declined.5': 'error.billing.adyen.do_not_honor',
    'Transaction declined.4': 'error.billing.adyen.approve_with_id',
    'Transaction declined.3': 'error.billing.adyen.new_account_information_available',
    'Transaction declined.2': 'error.billing.adyen.no_action_taken'
  },
  INR: {
    transaction_not_allowed: 'error.billing.stripe.transaction_not_allowed_inr'
  },
  ACH: {
    achBankABACode: 'billing.error.ach.bank_routing_number',
    achBankAccountNumber: 'billing.error.common.bank_account_number',
    achBankAccountType: 'billing.error.ach.bank_account_type',
    achBankName: 'billing.error.ach.bank_name',
    achBankAccountName: 'billing.error.ach.account_holder_name'
  },
  SEPA: {
    bankAccountNumber: 'billing.error.common.bank_account_number',
    bankAccountName: 'billing.error.sepa.bank_account_name',
    streetNumber: 'billing.error.sepa.street_number',
    streetName: 'billing.error.sepa.street_name',
    email: 'billing.error.sepa.account_email',
    country: 'billing.error.sepa.account_country'
  }
}

export const legacyCreditCardGateWay = 'CybersourceL2USD'

export const paymentGatewayMap = {
  Adyen: 'Adyen',
  Stripe: 'Stripe',
  PayPal: 'PayPal'
}

export const PaymentComponentName = 'Payment'

export const integrationTypeMap = {
  APM: 'APM',
  PayWithCC: 'PayWithCC',
  ApplePay: 'ApplePay',
  PayWithGoogle: 'PayWithGoogle',
  ACH: 'ACH',
  SEPA: 'SEPA'
}

export const achVerifyStatusMap = {
  pending: 'pending',
  retryExceeded: 'verify_retries_exceeded',
  failed: 'bank_account_verification_failed'
}

export const HpmValidationErrorMap = {
  Attempt_Exceed_Limitation: 'Attempt_Exceed_Limitation',
  Invalid_Security: 'Invalid_Security'
}

export const needCheckCreditFormFieldList = ['creditCardState', 'creditCardCity', 'creditCardCountry']

export const nonPayPalCurrencyList = ['IDR', 'INR', 'KRW', 'MYR', 'VND', 'SAR', 'ZAR', 'AED']

export const WISE = 'wise'

export const APM = 'APM'

export const APM_LOWERCASE = 'apm'

export const APM_UPDATE_PAYMENT_URL = '/apm/update'

export const WISE_SUCCESS_URL = '/apm/wise/success'

export const WISE_UPGRADE_SUCCESS_URL = '/apm/wise/payment/success?flow=update'

export const bizTypes = ['biz', 'mfg', 'adv', 'ps', 'fin', 'edu', 'med', 'util', 'telcomm', 'edu_high', 'sci_tech_inst', 'gov', 'bp', 'cnstr', 'ent', 'lgl', 'hpy', 'np', 'tech', 'trans', 're', 'other']

export const ttrTaxStatusList = {
  EXEMPT: 'EXEMPT',
  PENDING: 'PENDING',
  NON_EXEMPT: 'NON_EXEMPT',
  RETRIEVING: 'RETRIEVING'
}

export const flowTypes = {
  buyNow: 'buyNow',
  basic2pro: 'basic2pro',
  edit: 'edit',
  add2cart: 'add2cart',
  pro2biz: 'pro2biz',
  downgrade: 'downgrade',
  upgrade: 'upgrade',
  trial2paid: 'trial2paid'
}

export let planTypes = {
  WEBINAR: 'webinar',
  ZOOM_ROOMS: 'zoomroom',
  ZOOM_PHONE: 'pbx',
  ZOOM_PHONE$ZPA: 'pbx$zpa',
  ZOOM_PHONE$ZPI: 'pbx$zpi',
  ROOM_CONNECTOR: 'rc',
  LARGE_MEETING: 'large_meeting',
  TOLLFREE: 'tollfree',
  TOLLFREE$DID: 'tollfree$did',
  CMR: 'cmr',
  ZOOM_MEETING: 'zoom_meeting',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HIPAA_COMPLIANCE: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  ZOOM_EVENTS: 'zoom_events',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_WHITEBOARD: 'whiteboard',
  ZOOM_WHITEBOARD_PLUS: 'whiteboard_plus',
  ZOOM_ONE: 'zoomone',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION_CAPTIONS: 'translation_captions',
  VIDEO_SDK_TRANSLATION: 'video_sdk_translation',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  ZOOM_MESH: 'zoom_mesh',
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  ZVA: 'zva',
  Bundle_CREDIT: 'bundleCredit',
  LDKCRC: 'video_sdk_crc',
  API_CSP: 'api_csp',
  ZSU: 'ZSU',
  ZOOM_SCHEDULER: 'zoom_scheduler',
  ZONE_BASIC_PLUS: 'zone_basic_plus',
  ZONE_PPM: 'zone_ppm',
  MASTER_CLASS: 'masterclass',
  ZOOM_CLIPS: 'zoom_clips',
  VIDEO_SDK_UC: 'video_sdk_uc'
}

planTypes = new Enums(planTypes)

export const PAYMENT_ACTION_TYPE = {
  VIEW: 'view',
  EDIT: 'edit',
  UPDATE_EXPIRATION: 'update_expiration',
  ADD: 'add',
  SET_AS_PRIMARY: 'set_as_primary',
  REMOVE: 'remove',
  ENABLE_AUTO_PAY: 'enable_auto_pay'
}

export const ADYEN_PAY_METHOD = [payMethodMap.paypal, payMethodMap.google, payMethodMap.apple]

export const EVENT_ORIGIN_REG_EX = {
  PROD_DOMAINS:
    /^(((https?:\/\/)?(.+\.)*zoom\.us)|((https?:\/\/)?(.+\.)*zipow\.com)|((https?:\/\/)?(.+\.)*zoomgov\.com)|((https?:\/\/)?(.+\.)*zoomdev\.us)|((https?:\/\/)?(.+\.)*zoom\.cn)|((https?:\/\/)?(.+\.)*zoom\.com(\.cn)?)|((https?:\/\/)?(apisandbox|api|www)\.zuora\.com))$/,
  DEV_DOMAINS:
    /^(((https?:\/\/)?(.+\.)*zoom\.us)|((https?:\/\/)?(.+\.)*zipow\.com)|((https?:\/\/)?(.+\.)*zoomgov\.com)|((https?:\/\/)?(.+\.)*zoomext\.us)|((https?:\/\/)?(.+\.)*zoomdev\.us)|((https?:\/\/)?(.+\.)*zoom\.cn)|((https?:\/\/)?(.+\.)*zoom\.com(\.cn)?)|((https?:\/\/)?(apisandbox|api|www)\.zuora\.com))$/
}

export const APM_PROCESSOR_NAME = {
  STRIPE: 'stripe',
  ADYEN: 'adyen',
  WISE: 'wise'
}
